import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  type = 'warning',
  confirmText = 'تأكيد',
  cancelText = 'إلغاء',
  isLoading = false 
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return 'AlertTriangle';
      case 'success':
        return 'CheckCircle';
      case 'info':
        return 'Info';
      default:
        return 'AlertCircle';
    }
  };

  const getIconColor = () => {
    switch (type) {
      case 'danger':
        return 'text-error';
      case 'success':
        return 'text-success';
      case 'info':
        return 'text-accent';
      default:
        return 'text-warning';
    }
  };

  const getConfirmVariant = () => {
    switch (type) {
      case 'danger':
        return 'destructive';
      case 'success':
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <div className="fixed inset-0 z-300 bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="bg-popover border border-border rounded-lg shadow-elevation-3 w-full max-w-md animate-slide-up">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div className="flex items-center space-x-3">
              <Icon 
                name={getIcon()} 
                size={24} 
                className={getIconColor()} 
              />
              <h2 className="text-lg font-semibold text-popover-foreground font-arabic">
                {title}
              </h2>
            </div>
            
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              disabled={isLoading}
              iconName="X"
              iconSize={20}
              className="text-muted-foreground hover:text-foreground"
            />
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-popover-foreground leading-relaxed">
              {message}
            </p>
          </div>

          {/* Actions */}
          <div className="flex items-center justify-end space-x-3 p-6 border-t border-border bg-muted/30">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isLoading}
            >
              {cancelText}
            </Button>
            
            <Button
              variant={getConfirmVariant()}
              onClick={onConfirm}
              loading={isLoading}
              iconName={type === 'danger' ? 'Trash2' : 'Check'}
              iconPosition="left"
              iconSize={16}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>

      {/* Click outside to close */}
      <div 
        className="absolute inset-0 -z-10"
        onClick={onClose}
      />
    </div>
  );
};

export default ConfirmationDialog;